module.exports = __webpack_public_path__ + "img/tools1.50f93bb0.png";